import { grey } from "@/theme/palette";

import Stack from "@mui/material/Stack";

import { ClipboardCopy } from "@/components/atoms/ClipboardCopy";
// import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

import { useIsDarkMode } from "@/hooks/useIsDarkMode";

import { DebugButton } from "./DebugButton";
import { FeedbackButtons } from "./FeedbackButtons";
import { IStep } from "@/client/types";
import { useConfig } from "@/client/useConfig";
import { useChatMessages } from "@/client/useChatMessages";
// import { IconButton } from "@mui/material";

interface Props {
  message: IStep;
  run?: IStep;
}

const MessageButtons = ({ message, run }: Props) => {
  const isDark = useIsDarkMode();
  const { config } = useConfig();
  const { firstInteraction } = useChatMessages();

  // const isUser = message.type === "user_message";
  // const isAsk = message.waitForAnswer;
  const hasContent = !!message.content;
  const showCopyButton = hasContent;
  // const showCopyButton = true;

  const showDebugButton =
    !!config?.debugUrl && !!message.thread_id && !!firstInteraction;

  const show = showCopyButton || showDebugButton;

  if (!show || message.streaming) {
    return null;
  }

  return (
    <Stack
      sx={{ marginLeft: "-8px !important" }}
      alignItems="center"
      direction="row"
      color={isDark ? grey[400] : grey[600]}
    >
      {showCopyButton ? <ClipboardCopy value={message.content} /> : null}
      {/* <IconButton
        color="inherit"
        size="small"
        sx={{
          cursor: "pointer",
        }}
        aria-label="More options"
      >
        <MoreVertOutlinedIcon />
      </IconButton> */}

      {run ? <FeedbackButtons message={run} /> : null}
      {showDebugButton ? (
        <DebugButton debugUrl={config.debugUrl!} step={message} />
      ) : null}
    </Stack>
  );
};

export { MessageButtons };
